import _ from 'underscore';
import { tagTemplates } from './tag-template';

export const generateTag = (type, id, uglify = false, platformName, uetAutoSpaTracking = false) => {
  const updatedTagTemplate = _.map(tagTemplates[type], (line) => {
    let ret = line;
    if (uglify) {
      ret = ret.trim();
    }
    ret = ret.replace(/TAGID/, id.toString());
    ret = ret.replace(/, PLATFORM_PARAM/, platformName ? `, tm:"${platformName}"` : '');
    ret = ret.replace(/, SPA_PARAM/, uetAutoSpaTracking ? ', enableAutoSpaTracking: true' : '');
    return ret;
  });

  return uglify ?
    updatedTagTemplate.join('') :
    updatedTagTemplate.join('\n');
};
